var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlowCoin = function SvgGlowCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.515 3.515A11.962 11.962 0 0 0 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0a11.962 11.962 0 0 0-8.485 3.515Zm0 0C8.2 8.2 8.2 15.799 3.515 20.485c4.686-4.686 12.284-4.686 16.97 0-4.686-4.686-4.686-12.284 0-16.97C15.8 8.2 8.201 8.2 3.515 3.515Z",
    clipRule: "evenodd"
  })));
};
export default SvgGlowCoin;